<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > {{ 'Erros de Importação' | translate}}
    </div>
</div>

<main class="container">
    <h1>{{ 'Erros de Importação' | translate}}</h1>

    <div class="filtros">
        <div class="filtro">
            <label for="country">{{ 'País' | translate}}</label>
            <select id="country" [(ngModel)]="filtro.country">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let pais of listaPaises" [value]="pais.countryCode">{{pais.name}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="year">{{ 'Ano' | translate}}</label>
            <select id="year" [(ngModel)]="filtro.year">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let ano of listaAno" [value]="ano">{{ano}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="month">{{ 'Mês' | translate}}</label>
            <select id="month" [(ngModel)]="filtro.month">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let mes of listaMes" [value]="mes">{{mes}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="pdv">{{ 'PDV' | translate}}</label>
            <select id="pdv" [(ngModel)]="filtro.pdv">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let pdv of listaPDVs" [value]="pdv">{{pdv}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="provider">{{ 'Provedor' | translate}}</label>
            <select id="provider" [(ngModel)]="filtro.provider">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let provedor of listaProvedor" [value]="provedor">{{provedor}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="fileName">{{ 'Arquivo (zip)' | translate}}</label>
            <input type="text" id="fileName" [(ngModel)]="filtro.fileName" />
        </div>
        <div class="filtro">
            <label>&nbsp;</label>
            <button (click)="consultar()" class="red_button">{{ 'Consultar' | translate }}</button>
        </div>
        <div class="filtro">
            <label>&nbsp;</label>
            <button (click)="limparFiltro()" class="red_button">{{ 'Limpar' | translate}}</button>
        </div>
    </div>

    <table border="0" cellpadding="0" cellspacing="0">
        <thead>
            <tr>
                <th>{{ 'Arquivo (zip)' | translate}}</th>
                <th>{{ 'Caminho de origem' | translate}}</th>
                <th>{{ 'Qtd. imagens' | translate}}</th>
                <th>{{ 'Tipo de erro' | translate}}</th>
                <th>{{ 'Download' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of listaItens">
                <td>{{item.fileName}}</td>
                <td>{{item.originPath}}</td>
                <td>{{item.filesCount}}</td>
                <td>{{item.errorType}}</td>
                <td>
                    <button (click)="baixarArquivo(item)" class="red_button" [title]="'Baixar arquivos' | translate">
                        {{ 'Baixar' | translate}}
                    </button>
                </td>
            </tr>
            <tr *ngIf="listaItens.length === 0">
                <td colspan="5" class="text-center">{{ 'Nenhum erro de importação encontrado.' | translate}}</td>
            </tr>
        </tbody>
    </table>

    <div class="pagination-info" *ngIf="totalItems > 0">
        <button (click)="paginaAnterior()" [disabled]="currentPage <= 1">{{ '<' }}</button>
        <span>{{ 'Página' | translate}} {{currentPage}} {{ 'de' | translate}} {{totalPages}} - {{ 'total de itens' | translate}}: {{totalItems}}</span>
        <button (click)="proximaPagina()" [disabled]="currentPage >= totalPages">{{ '>' }}</button>
    </div>
</main>
